import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export const useWordGroupsData = (moduleId) => {
  const [wordGroups, setWordGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadWordGroups = useCallback(async () => {
    if (!moduleId) {
      setWordGroups([]);
      setLoading(false);
      return;
    }


    setLoading(true);
    setError('');

    try {
      // Get user session
      const { data: { session } } = await supabase.auth.getSession();
      const userId = session?.user?.id;
      
      if (!userId) {
        setError('User not authenticated');
        return;
      }

      const { data, error: fetchError } = await supabase
        .from('word_groups')
        .select('*')
        .eq('module_id', moduleId)
        .order('position', { ascending: false });

      if (fetchError) {
        setError('Error fetching word groups');
        return;
      }

  
      setWordGroups(data || []);
    } catch (err) {
      setError('Error fetching word groups');
    } finally {
      setLoading(false);
    }
  }, [moduleId]);

  useEffect(() => {
    if (moduleId) {
      loadWordGroups();
    } else {
      setWordGroups([]);
      setLoading(false);
    }
  }, [moduleId, loadWordGroups]);

  return {
    wordGroups,
    loading,
    error,
    refetch: loadWordGroups,
  };
};
